import { render, staticRenderFns } from "./ModalShiftInfo.vue?vue&type=template&id=0fcb4a95"
import script from "./ModalShiftInfo.vue?vue&type=script&lang=js"
export * from "./ModalShiftInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalShiftInfo.vue?vue&type=style&index=0&id=0fcb4a95&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports